<template>
    <div class="interface">
        <div class="tabBar">
            <ul>
                <li v-for="(key,index) in $t('interface.tabBar')" :key="index">{{key}}</li>
            </ul>
        </div>
        <div class="bannerW">
            <div class="leftTab">
                <ul>
                    <li v-for="(key,index) in $t('interface.tianqinTab')" :class="{'isActive':index==0}" :key="index">{{key}}</li>
                </ul>
            </div>
            <div class="rightCon"></div>
        </div>
    </div>
</template>
<script>
    export default{
        name:"interface",
        data(){
            return {

            }
        }
    }
</script>
<style lang="scss" scoped>
    .interface{
        .tabBar{
            width: 100%;
            background:rgba(249,249,249,1);
            ul{
                display: flex;
                flex-direction:row;
                justify-content:center;
                li{
                    width:90px;
                    height:28px;
                    font-size:20px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(0,0,0,1);
                    padding:35px 0px;
                    text-align: center;
                    &:hover{
                        border-bottom: 6px solid rgba(0,161,255,1);
                    }
                }
            }
        }
        .leftTab{
            ul{
                margin-top:34px;
                width:266px;
                
                li{
                    padding:0 13px;
                    box-sizing:border-box;
                    margin-top:8px;
                    height:40px;
                    font-size:16px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(34,34,34,1);
                    line-height:40px;
                }
                li.isActive{
                    background:rgba(238,238,238,1);
                }
            }
        }
    }
  
</style>